<div class="main-container">
    <p>
        <span class="error-status">503</span> 
        <span class="error-title">Service Unavailable</span>
    </p>
    <br>
    <p class="description">Server maintenance.</p>
    <p class="description">Please try again later.</p>
</div>